<template>
  <AllRecordsTable
    submit-button-text="Добавить наряд-заказ"
    table-name="purchase_orders"
    link-slug="purchase_orders"
    title="Наряд-заказы"
    :columns="ordersTable.columnNames"
    :row-links="ordersTable.rowLinks"
    :filter-fields="ordersTable.filterFields"
    :order-fields="ordersTable.orderFields"
    :rows="ordersTable.rowNames"
  />
</template>

<script>
import AllRecordsTable from "@/_shared/widgets/AllRecordsTable";
import { lists } from '@/stock/constants';
export default {
  components: {
    AllRecordsTable,
  },
  data() {
    return {
      ordersTable: lists.purchaseOrders,
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/pages/AllPurchaseOrdersPage.vue